// infra/supabaseClient.js
// Client Supabase unique (singleton) — partagé par tout le jeu.
// - Utilise window.supabase (chargé via CDN dans index.html)
// - Persiste la session (persistSession)
// - Expose aussi une référence globale pour debug/compat: window.__bulleSupabaseClient

let _client = null;
let _sig = "";

function sigFor(url, key){
  return `${String(url||"").trim()}::${String(key||"").trim().slice(0,16)}`;
}

export function createSupabaseClient({ url, anonKey }){
  const sb = window.supabase;
  if(!sb || !sb.createClient){
    throw new Error("Supabase CDN non chargé");
  }
  const u = String(url||"").trim();
  const k = String(anonKey||"").trim();
  if(!u || !k) throw new Error("Config Supabase manquante");

  const sig = sigFor(u, k);

  if(_client && sig === _sig) return _client;

  // Reuse shared global if same sig (avoid multiple GoTrueClient instances)
  try{
    const shared = window.__bulleSupabaseClient;
    const sharedSig = window.__bulleSupabaseSig;
    if(shared && shared.auth && sharedSig === sig){
      _client = shared;
      _sig = sig;
      return _client;
    }
  }catch(_e){}

  _sig = sig;
  _client = sb.createClient(u, k, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  });

  try{
    window.__bulleSupabaseClient = _client;
    window.__bulleSupabaseSig = sig;
  }catch(_e){}

  return _client;
}

export function getSupabaseClient(){
  if(!_client) throw new Error("Supabase client non initialisé");
  return _client;
}

export function getSupabaseSig(){
  return _sig;
}
